import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { FormPageComponent } from '../../common/form/form.component';

@Component({
  selector: 'signup-completed',
  templateUrl: './signup-completed.component.html',
  standalone: true,
  styleUrl: './signup-completed.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgIconComponent, FormPageComponent],
})
export class SignUpCompletedComponent {
  constructor() {}
}
